import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FloorNumberFailure, FloorNumberRequest, FloorNumberSuccess } from './actions';
import { FloorNumberService } from './service';

@Injectable()
export class FloorNumberEffects {
  private readonly actions$ = inject(Actions);
  private readonly floorNumberService = inject(FloorNumberService);

  floorNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FloorNumberRequest),
      switchMap(({ parameters }) =>
        this.floorNumberService.floorNumber(parameters).pipe(
          map(data => FloorNumberSuccess({ data })),
          catchError(error => of(FloorNumberFailure({ error })))
        )
      )
    )
  );

}
